import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import api from "../lib/api";
import { FadeUp } from "../components/Reveal";

export default function AdminClients() {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    api.get("/admin/clients").then((r) => setClients(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-clients">
      <FadeUp>
        <h1 className="font-serif text-3xl sm:text-4xl text-obsidian">Clients</h1>
        <p className="text-sm text-slate-500 mt-2">Every account, their bookings and their projects.</p>
      </FadeUp>
      <div className="mt-10 grid gap-5 md:grid-cols-2">
        {clients.map((c) => (
          <FadeUp key={c.user_id} className="bg-white rounded-2xl border border-purple-100 p-6" data-testid={`client-card-${c.user_id}`}>
            <div className="flex items-center gap-4">
              <span className="w-12 h-12 rounded-full bg-purple-700 text-white flex items-center justify-center font-semibold shrink-0">
                {c.name?.[0]?.toUpperCase() || "?"}
              </span>
              <div className="min-w-0">
                <p className="font-medium text-obsidian truncate">{c.name}</p>
                <p className="text-xs text-slate-400 truncate">{c.email}{c.phone ? ` · ${c.phone}` : ""}</p>
              </div>
            </div>
            <div className="flex items-center gap-6 mt-5 text-sm">
              <span className="text-slate-500"><span className="font-serif text-xl text-obsidian">{c.booking_count}</span> bookings</span>
              <span className="text-slate-500"><span className="font-serif text-xl text-obsidian">{c.project_count}</span> projects</span>
              <Link to="/admin/messages" data-testid={`client-message-${c.user_id}`}
                className="ml-auto w-9 h-9 rounded-full bg-lilac-mist flex items-center justify-center text-purple-700 hover:text-gold transition-colors" aria-label={`Message ${c.name}`}>
                <MessageCircle size={15} />
              </Link>
            </div>
          </FadeUp>
        ))}
        {clients.length === 0 && <p className="text-sm text-slate-400 italic">No clients yet.</p>}
      </div>
    </div>
  );
}
